/** Configuration metadata only: no provider fallback is invented by the client. */
export function parseProcessors(value: unknown): string[] | null {
  if (!Array.isArray(value) || value.length > 8) return null;
  if (
    !value.every(
      (name) =>
        typeof name === 'string' && name.trim() === name && name.length > 0 && name.length <= 80,
    )
  )
    return null;
  return [...new Set(value)];
}

export function formatProcessors(processors: string[], locale: string): string {
  return new Intl.ListFormat(locale, { type: 'disjunction' }).format(processors);
}
